/**
 * Digests API — on-demand `/today` / `/week`.
 */
import { request } from "./client";
import type {
  DigestPeriod,
  DigestRequest,
  DigestResponse,
} from "../lib/types";

export async function buildDigest(
  period: DigestPeriod,
  projectId?: string | null,
  signal?: AbortSignal,
): Promise<DigestResponse> {
  const body: DigestRequest = {
    period,
    project_id: projectId ?? null,
  };
  return request<DigestResponse>("/api/v1/digests", {
    method: "POST",
    body,
    signal,
  });
}
